module.exports = __webpack_public_path__ + "static/img/WechatIMG213.7b7b848.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/WechatIMG213.jpeg
// module id = 1bGP
// module chunks = 12